// extracted by mini-css-extract-plugin
module.exports = {"clickable":"WalletConnectModal_clickable__2UYOs"};